module.exports = __webpack_public_path__ + "img/brands.d5ca6f4a.png";